import * as React from 'react';
import type { FC } from 'react';
import { useLocales } from './locales';
import iconHide from './images/icon_banner_hide.svg';
import iconShow from './images/icon_banner_show.svg';

// A view setting rather than a filter: it never starts a search.
const BannerToggle: FC<{ hidden: boolean; onToggle: () => void }> = ({ hidden, onToggle }) => {
  const l = useLocales();

  return (
    <button
      type="button"
      className="filters_end-button"
      aria-expanded={!hidden}
      aria-controls="xo-banner"
      onClick={onToggle}
    >
      <img src={hidden ? iconShow : iconHide} alt="" />
      {/* The button's name, shown as its tooltip on hover */}
      <span className="filters_end-button-label">{l(hidden ? 'show_banner' : 'hide_banner')}</span>
    </button>
  );
};

export default BannerToggle;
